import { render, staticRenderFns } from "./AddEditConfigurationItem.vue?vue&type=template&id=53fc6f1f"
import script from "./AddEditConfigurationItem.vue?vue&type=script&lang=js"
export * from "./AddEditConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./AddEditConfigurationItem.vue?vue&type=style&index=0&id=53fc6f1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports